<!--
  +---------------------------------------------------------------------------------------
  | @Copyright: Frippler Copyright (c)
  | @Title:     用户头像
  +---------------------------------------------------------------------------------------
-->
<template>
  <el-image class="f-user-avatar image" :class="{ [size]: size, [shape]: shape }" :src="user.avatar"
    :preview-src-list="preview ? [user.avatar] : []">
    <div slot="error">
      <div class="image" :class="{ [size]: size, [shape]: shape }"
        :style="{ color: fill ? '#fff' : scolor, background: fill ? scolor : 'transparent', 'border-color': scolor }">{{
        title.slice(-2) }}</div>
    </div>
  </el-image>
</template>

<script>
export default {
  name: 'FUserAvatar',

  props: {
    user: {
      type: Object,
      default () {
        return {}
      }
    },

    size: {
      type: String,
      default: ''
    },

    preview: {
      type: Boolean,
      default: true
    },

    fill: {
      type: Boolean,
      default: true
    },

    shape: {
      type: String,
      default: 'circle'
    }
  },

  data () {
    return {
      showFont: ''
    }
  },

  computed: {
    title () {
      return this.user.nickname || this.user.username || this.user.name || this.user.principal_name || '用户'
    },

    scolor () {
      let uid = this.user.uid || this.user.principal
      switch (uid % 5) {
        case 0:
          return '#07c160'
        case 1:
          return '#e6a23c'
        case 2:
          return '#f56c6c'
        case 3:
          return '#409eff'
        case 4:
          return '#997bec'
        default:
          return '#999'
      }
    }
  },

  mounted () { },

  methods: {}
}
</script>
<style scoped lang='scss'>
.f-user-avatar {
  .image {
    text-align: center;
    line-height: 38px;
    font-size: 16px;
    // font-weight: bolder;
    border: 1px solid #999;
  }

  .large {
    line-height: 46px;
    font-size: 18px;
  }

  .larger {
    line-height: 58px;
    font-size: 24px;
  }

  .huge {
    line-height: 96px;
    font-size: 42px;
    border-width: 2px;
  }

  .huger {
    line-height: 192px;
    font-size: 84px;
    border-width: 4px;
  }

  .small {
    line-height: 36px;
    font-size: 14px;
  }

  .mini {
    line-height: 28px;
    font-size: 12px;
  }
}
</style>
